document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.querySelector('.cart-drawer');
  const atcBtn = document.querySelector('.product-form--atc-button');

  function bindCartEvents() {
    const closeCartBtn = document.querySelector('.cart-drawer--close');
    const cartOverlay = document.querySelector('.cart-drawer-overlay');
    const openCartBtn = document.querySelector('.cart-drawer-button');

    if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
    if (openCartBtn) openCartBtn.addEventListener('click', openCart);
  }

  function openCart() {
    const cartDrawer = document.querySelector('.cart-drawer');
    const cartItemsList = document.querySelector('.cartitems--list');

    if (cartItemsList) {
      refreshSideCart();
    }
    if (cartDrawer) {
      cartDrawer.classList.remove('cart-drawer-hidden');
    } else {
      console.error('Cart drawer not found');
    }
  }

  function closeCart() {
    const cartDrawer = document.querySelector('.cart-drawer');
    cartDrawer.classList.add('cart-drawer-hidden');
  }

  function renderCartItem(item) {
    let firstOption = item.options_with_values[0].name;

    let hasOptions = false;
    if (firstOption !== 'Title') {
      hasOptions = true;
    }
  return `
    <li class="cart-item"
        data-cartitem
        data-cartitem-id="${item.variant_id}"
        data-cartitem-key="${item.key}"
        data-cartitem-price="${item.final_line_price}">
      
      <figure class="cart-drawer-item--image-wrapper">
        <img src="${item.image}" width="75"/>
      </figure>

      <div class="cart-item--inner cart-drawer-item--inner">
        <div class="cart-item--content cart-drawer-item--content">
          <h2 class="cart-item--content-title">
            <a href="${item.url}">${item.product_title}</a>
          </h2>
          <div class="cart-item-sku"><strong>SKU</strong> <span data-product-sku>${item.sku}</span></div>
          <div class="cart-item--content-price">
            <span class="cart-item--price-title">Price</span>
            <span class="money">$${(item.final_price / 100).toFixed(2)}</span>
          </div>
          
          ${hasOptions ? `
            <div class="cart-item-product-options">
              ${item.options_with_values.map(opt => {
                if (opt.name === 'Title' && opt.value === 'Default Title') return '';
                return `
                  <dl class="cart-item-product-options__option">
                    <dt class="cart-item-product-options__option-key">${opt.name}:</dt>
                    <dd class="cart-item-product-options__option-value">${opt.value}</dd>
                  </dl>
                `;
              }).join('')}
            </div>
          ` : ''}

        </div>

        <div class="cart-item__info">
          <div class="cart-item__total">
            <div class="money" aria-live="polite" data-cartitem-total>
              <p>x ${item.quantity}</p>
              $${(item.final_line_price / 100).toFixed(2)}
            </div>
          </div>
        </div>
      </div>
    </li>
  `;
}

function renderEmptyCart() {
  return `
    <div class="cartitems-empty">
      <div class="cartitems-empty--inner">
        <p>Your cart is empty.</p>
        <a class="cart-continue" href="/collections/all">Continue shopping</a>
      </div>
    </div>
  `;
}

function refreshSideCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartItemsContainer = document.querySelector('.cartitems--list');
      const continueToCart = document.querySelector('.cart-drawer--button_to_cart');
      const cartTotals = document.querySelector('.cart-total');
      const subtotalPrice = document.querySelector('.cart-drawer-subtotal');
      cartItemsContainer.innerHTML = ''; // Clear existing items
      subtotalPrice.innerHTML = `Subtotal: $${(cart.total_price / 100).toFixed(2)} <p>Taxes and shipping calculated at checkout.</p>`

      if (cart.item_count > 0) {
        cartTotals.classList.remove('cart-drawer-hidden');
        cart.items.forEach(item => {
          cartItemsContainer.insertAdjacentHTML('beforeend', renderCartItem(item));
        });
        if (cart.items.length > 5) {
        continueToCart.classList.remove('cart-drawer-hidden');
        }
      }
      else {
        continueToCart.classList.add('cart-drawer-hidden');
        cartTotals.classList.add('cart-drawer-hidden');
        cartItemsContainer.insertAdjacentHTML('beforeend', renderEmptyCart());
      }

      bindCartEvents(); // Rebind any necessary events
    })
    .catch(err => console.error('Error refreshing cart:', err));
}

  bindCartEvents();

});
